import React from 'react'
import styled from '@emotion/styled'
import { withTheme } from 'emotion-theming'
import { string } from 'prop-types'

//styled components
const CardWrapper = styled.div`
	margin: auto;
	width: 100%;
`
const TestimonialContent = styled.div`
	background-color: #fff;
	width: 100%;
	text-align: left;
	min-height: 260px;

	${({ theme }) => theme.MQ.M} {
		height: 20vh;
		min-height: 270px;
	}
	${({ theme }) => theme.MQ.MAX} {
		height: 15vh;
		min-height: 250px;
	}
	@media (min-width: 768px) and (max-width: 800px) {
		height: 30vh;
		min-height: 270px;
	}
`
const ContentWrapper = styled.div`
	padding: 20px;
	${({ theme }) => theme.MQ.M} {
		padding: 50px;
	}
	${({ theme }) => theme.MQ.MAX} {
		padding: 40px;
	}
	@media (min-width: 768px) and (max-width: 800px) {
		padding: 40px;
	}
`
const ClientDetails = styled.div`
	background-color: ${({ theme }) => theme.colors.teal};
	width: 100%;
	height: 10vh;
	min-height: 150px;
	color: #fff;
	text-align: left;
`
const ClientDetailsWrapper = styled.div`
	padding: 50px 20px;
	${({ theme }) => theme.MQ.M} {
		padding: 40px;
	}
`
const Title = styled.div`
	${({ theme }) => theme.header.h3};
	color: ${({ theme }) => theme.colors.navy};
	padding: 10px;
	${({ theme }) => theme.MQ.M} {
		padding: 0px 40px;
	}
`

const Quote = styled.p`
	color: ${({ theme }) => theme.colors.darkGrey};
	${({ theme }) => theme.text.bodySmall};
	padding: 10px;
	margin: 0;
	${({ theme }) => theme.MQ.M} {
		padding: 10px 40px;
	}
`
const ClientName = styled.div`
	display: block;
	${({ theme }) => theme.header.h3};
	padding: 0 10px;
	${({ theme }) => theme.MQ.M} {
		padding: 0px 40px;
	}
`
const Role = styled.div`
	display: block;
	${({ theme }) => theme.text.bodySmall};
	padding: 5px 10px;
	${({ theme }) => theme.MQ.M} {
		padding: 5px 40px;
	}
`

CardQuoteStyled.propTypes = {
	clientName: string,
	content: string,
	industry: string,
	title: string,
}

/**
 * This component is a styled card quote for testimonials, it displays the content of each
 * testimonial in a card
 */
function CardQuoteStyled({ content, clientName, industry, title }) {
	return (
		<CardWrapper>
			<TestimonialContent>
				<ContentWrapper>
					<Title>{title}</Title>
					<Quote>{content}</Quote>
				</ContentWrapper>
			</TestimonialContent>
			<ClientDetails>
				<ClientDetailsWrapper>
					<ClientName>{clientName}</ClientName>
					<Role>{industry}</Role>
				</ClientDetailsWrapper>
			</ClientDetails>
		</CardWrapper>
	)
}

export default withTheme(CardQuoteStyled)
